import React from 'react'
import Login from './Login'
import Register from './Register'
import ForgotPass from './ForgotPass'
const Authenticate = props => {
  return (
    <div class="container-fluid" style={{ width: '50%' }}>
      <ul class="nav nav-tabs">
        <li class="active"><a data-toggle="tab" href="#Login_Tab">Login</a></li>
        <li><a data-toggle="tab" href="#Register_Tab">Register</a></li>
        <li><a data-toggle="tab" href="#forgot_Tab">Forgot Password</a></li>
      </ul>

      <div class="tab-content">
        <div id="Login_Tab" class="tab-pane fade in active">
          <Login />
        </div>
        <div id="Register_Tab" class="tab-pane fade">
          <Register />
        </div>
        <div id="forgot_Tab" class="tab-pane fade">
          <ForgotPass />
        </div>

      </div>
    </div>
  )
}



export default Authenticate
